export const defaultAccountDrawerChildren = [
    {
        '@type': '@builder.io/sdk:Element' as const,
        component: {
            name: 'Core:Button',
            options: {
                variant: 'primary',
                disabled: false,
                clickFunction: 'Nothing',
                isInternalLink: true,
                openInNewTab: false
            }
        },
        children: [
            {
                '@type': '@builder.io/sdk:Element' as const,
                component: {
                    name: 'Text',
                    options: {
                        text: '<p>Account Drawer Trigger</p>'
                    }
                }
            }
        ],
        responsiveStyles: {
            large: {
                marginTop: '20px',
                marginBottom: '20px',
                paddingLeft: '20px',
                paddingRight: '20px',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        }
    }
]
